export enum SERVICE_TYPE {
  MICHELIN = "michelin",
  HOTPOT = "hotpot",
}

export type ServiceType = SERVICE_TYPE.MICHELIN | SERVICE_TYPE.HOTPOT
